export default __webpack_public_path__ + "static/media/ArrowRight.af1938cf.svg";